/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `sdm_profile` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class SdmProfileMesg : Mesg {
    public constructor() : super("SdmProfile", Profile.MesgNum.SDM_PROFILE)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** enabled. */
    public var enabled: Boolean?
        get() = (getFieldValue(ENABLED_FIELD_NUM) as? UByte)?.let { it.toInt() != 0 }
        set(value) = setFieldValue(ENABLED_FIELD_NUM, value?.let { if (it) 1 else 0 })

    /** sdm_ant_id. */
    public var sdmAntId: UShort?
        get() = getFieldValue(SDM_ANT_ID_FIELD_NUM) as? UShort
        set(value) = setFieldValue(SDM_ANT_ID_FIELD_NUM, value)

    /** sdm_cal_factor, in %. */
    public var sdmCalFactor: Double?
        get() = getFieldValue(SDM_CAL_FACTOR_FIELD_NUM) as? Double
        set(value) = setFieldValue(SDM_CAL_FACTOR_FIELD_NUM, value)

    /** odometer, in m. */
    public var odometer: Double?
        get() = getFieldValue(ODOMETER_FIELD_NUM) as? Double
        set(value) = setFieldValue(ODOMETER_FIELD_NUM, value)

    /** speed_source. Use footpod for speed source instead of GPS */
    public var speedSource: Boolean?
        get() = (getFieldValue(SPEED_SOURCE_FIELD_NUM) as? UByte)?.let { it.toInt() != 0 }
        set(value) = setFieldValue(SPEED_SOURCE_FIELD_NUM, value?.let { if (it) 1 else 0 })

    /** sdm_ant_id_trans_type. */
    public var sdmAntIdTransType: UByte?
        get() = getFieldValue(SDM_ANT_ID_TRANS_TYPE_FIELD_NUM) as? UByte
        set(value) = setFieldValue(SDM_ANT_ID_TRANS_TYPE_FIELD_NUM, value)

    /** odometer_rollover. Rollover counter that can be used to extend the odometer */
    public var odometerRollover: UByte?
        get() = getFieldValue(ODOMETER_ROLLOVER_FIELD_NUM) as? UByte
        set(value) = setFieldValue(ODOMETER_ROLLOVER_FIELD_NUM, value)

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val ENABLED_FIELD_NUM: UByte = 0u
        public const val SDM_ANT_ID_FIELD_NUM: UByte = 1u
        public const val SDM_CAL_FACTOR_FIELD_NUM: UByte = 2u
        public const val ODOMETER_FIELD_NUM: UByte = 3u
        public const val SPEED_SOURCE_FIELD_NUM: UByte = 4u
        public const val SDM_ANT_ID_TRANS_TYPE_FIELD_NUM: UByte = 5u
        public const val ODOMETER_ROLLOVER_FIELD_NUM: UByte = 7u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("Enabled", 0u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[1] = Field("SdmAntId", 1u, BaseType.UINT16Z, 1.0, 0.0, "", false)
            fields[2] = Field("SdmCalFactor", 2u, BaseType.UINT16, 10.0, 0.0, "%", false)
            fields[3] = Field("Odometer", 3u, BaseType.UINT32, 100.0, 0.0, "m", false)
            fields[4] = Field("SpeedSource", 4u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[5] = Field("SdmAntIdTransType", 5u, BaseType.UINT8Z, 1.0, 0.0, "", false)
            fields[7] = Field("OdometerRollover", 7u, BaseType.UINT8, 1.0, 0.0, "", false)
            return fields
        }
    }
}
